<template>
    <div>
        <h1>SELECT MODE DARK AND WHITE</h1>
    </div>
</template>

